<template>
  <div>
    <div class="page_title">会员管理</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="searchbox">
          <div>
            <span>首次开通时间</span>
            <el-date-picker
              v-model="date1"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:225px;margin-left:10px"
              @change="search"
            ></el-date-picker>
          </div>
          <div
            class="item"
            style="margin-left:38px"
          >
            <span>姓名</span>
            <el-input
              placeholder="请输入"
              v-model="real_name"
              style="width:150px;margin-left:10px"
              @input="search"
              clearable
            ></el-input>
          </div>

          <div class="item">
            <span>消费金额</span>
            <el-input
              v-model="min_pay_money"
              style="width:100px;margin-left:10px"
              clearable
              type="number"
              @input="search"
              placeholder="最小"
            ></el-input>
            <span style="margin:0 10px">~</span>
            <el-input
              v-model="max_pay_money"
              style="width:100px;"
              clearable
              @input="search"
              placeholder="最大"
            ></el-input>
          </div>
          <div class="item">
            <span style="margin-right:10px">状态</span>
            <el-radio
              v-model="expire_status"
              :label="0"
              @change="search"
            >全部</el-radio>
            <el-radio
              v-model="expire_status"
              :label="1"
              @change="search"
            >已到期</el-radio>
            <el-radio
              v-model="expire_status"
              :label="2"
              @change="search"
            >未到期</el-radio>
          </div>
        </div>
        <div class="searchbox">
          <div>
            <span style="display:inline-block;text-align:right;width:84px">到期时间</span>
            <el-date-picker
              v-model="date2"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:225px;margin-left:10px"
              @change="search"
            ></el-date-picker>
          </div>
          <div class="item">
            <span>手机号</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width:150px;margin-left:10px"
              @input="search"
              clearable
            ></el-input>
          </div>

          <div class="item">
            <span>消费次数</span>
            <el-input
              v-model="min_buy_count"
              style="width:100px;margin-left:10px"
              clearable
              type="number"
              @input="search"
              placeholder="最小"
            ></el-input>
            <span style="margin:0 10px">~</span>
            <el-input
              v-model="max_buy_count"
              style="width:100px;margin-right:20px"
              clearable
              @input="search"
              placeholder="最大"
            ></el-input>
            <el-button
              type="primary"
              @click="search"
            >查询</el-button>
            <el-button
              type="plain"
              @click="reset"
            >重置</el-button>
          </div>
        </div>

        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%;min-width:1040px;"
            :header-cell-style="{background:'#F5F5F5'}"
            @sort-change="changeOrder"
          >
            <el-table-column
              prop="create_time"
              label="首次开通时间"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="expire_time"
              label="到期时间"
              sortable="custom"
            ></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.expire_time<scope.row.now_time">已过期</div>
                <div v-else>未过期</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="real_name"
              label="姓名"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
            ></el-table-column>
            <el-table-column
              label="消费金额（元）"
              prop="pay_money"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              label="消费次数"
              prop="buy_count"
              sortable="custom"
            ></el-table-column>
            <el-table-column
              prop="price"
              label="单均价（元）"
            ></el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="todetail(scope.row.user_id)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      real_name: '',
      min_pay_money: '',
      max_pay_money: '',
      phone: '',
      min_buy_count: '',
      max_buy_count: '',
      expire_status: 0,
      date1: [],
      date2: []
    };
  },

  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList(sort) {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        real_name: this.real_name,
        min_pay_money: this.min_pay_money,
        max_pay_money: this.max_pay_money,
        phone: this.phone,
        min_buy_count: this.min_buy_count,
        max_buy_count: this.max_buy_count,
        expire_status: this.expire_status,
        sort: sort
      };
      if (this.date1 && this.date1.length > 0) {
        data.start_create_time = dayjs(this.date1[0]).format('YYYY-MM-DD');
        data.end_create_time = dayjs(this.date1[1]).format('YYYY-MM-DD');
      }
      if (this.date2 && this.date2.length > 0) {
        data.start_expire_time = dayjs(this.date2[0]).format('YYYY-MM-DD');
        data.end_expire_time = dayjs(this.date2[1]).format('YYYY-MM-DD');
      }

      this.axios.post('platform/shop/getUserMemberList', data).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.list.map((item) => {
            item.create_time = dayjs
              .unix(item.create_time)
              .format('YYYY-MM-DD HH:mm');
            item.expire_time = dayjs
              .unix(item.expire_time)
              .format('YYYY-MM-DD HH:mm');
            if (item.pay_money && item.buy_count) {
              item.price = Math.floor(item.pay_money / item.buy_count);
            }
            item.now_time = dayjs(Date.now()).format('YYYY-MM-DD HH:mm');

            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },

    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.nick_name = '';
      this.min_pay_money = '';
      this.max_pay_money = '';
      this.phone = '';
      this.min_buy_count = '';
      this.max_buy_count = '';
      this.date1 = [];
      this.date2 = [];
      this.getList();
    },
    //修改排序
    //1首次开通时间倒叙，2首次开通时间升序，3到期时间倒叙，4到期时间升序，5消费金额倒叙，6消费金额升序，7消费次数倒叙，8消费次数升序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      let sort = '';
      //升序
      if (order == 'ascending') {
        if (prop == 'create_time') {
          sort = 2;
        } else if (prop == 'expire_time') {
          sort = 4;
        } else if (prop == 'pay_money') {
          sort = 6;
        } else if (prop == 'buy_count') {
          sort = 8;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'create_time') {
          sort = 1;
        } else if (prop == 'expire_time') {
          sort = 3;
        } else if (prop == 'pay_money') {
          sort = 5;
        } else if (prop == 'buy_count') {
          sort = 7;
        }
      }
      this.getList(sort);
    },
    //详情
    todetail(user_id) {
      this.$router.push({
        path: '/home/patient/userdetail',
        query: {
          user_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.searchbox {
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  .item {
    margin-left: 24px;
  }
}
</style>
<style lang="scss">
.searchbox input::-webkit-outer-spin-button,
.searchbox input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.searchbox input[type='number'] {
  -moz-appearance: textfield;
}
</style>